import { render, staticRenderFns } from "./FirmwideEmissionByCorp.vue?vue&type=template&id=080929d0"
import script from "./FirmwideEmissionByCorp.vue?vue&type=script&lang=js"
export * from "./FirmwideEmissionByCorp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports